module.exports = __webpack_public_path__ + "5ee0f2d1a1e6e14d8c4d8fa7f18c3326.ttf";


//////////////////
// WEBPACK FOOTER
// ../public/fonts/Luckiest_Guy/LuckiestGuy.ttf
// module id = 391
// module chunks = 7